import {useTranslation} from 'react-i18next'
import {PaymentSettingsIcon} from '../../../icons'
import {useAppNavigation} from '../../../hooks/useAppNavigation'

export const stepName = 'connectExpenseAccount'

const calculateStatus = ({connectedExpenseAccount}) => {
  if (connectedExpenseAccount === true) {
    return 'completed'
  }

  return 'incomplete'
}

export default (stepperData) => {
  const navigate = useAppNavigation()
  const {t} = useTranslation('connectExpenseAccount')

  const handleOnClick = () => {
    navigate('/connect_expense_account')
  }

  const status = calculateStatus(stepperData)
  const prerequisiteStepsCompleted =
    stepperData.verificationStatus === 'verified' &&
    stepperData.supplierAgreementAccepted

  return {
    name: stepName,
    visible: true,
    status,
    active: status === 'incomplete' && prerequisiteStepsCompleted,
    icon: <PaymentSettingsIcon />,
    title: t('stepper.title'),
    subtitle: {default: t('stepper.tooltip')},
    action: {
      label: t('stepper.button'),
      onClick: handleOnClick,
    },
  }
}
